export default {
  oat: `__${process.env.GATSBY_THEME}-oat__`,
  errorBanner: `__${process.env.GATSBY_THEME}-current-errors__`,
};
